import CanadianFlagIcon from "../../../assets/images/canadian-flag.svg";
import IndoorFootballIcon from "../../../assets/images/indoor-football.svg";

export const IconMap = {
	"canadian-flag": CanadianFlagIcon,
	"indoor-football": IndoorFootballIcon
};
